(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["goodays-countdown"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('goodays-countdown')) {
  customElements.define('goodays-countdown', class extends HTMLElement {
    connectedCallback() {
      const date = this.dataset.date;
      const time = this.dataset.time;
      if (!/^\d{4}-\d{2}-\d{2}$/.test(date) || !/^\d{2}:\d{2}$/.test(time)) return;
      const parts = `${date}T${time}`.split(/[-T:]/).map(Number);
      const [y,m,d,h,min] = parts;
      const wall = Date.UTC(y,m-1,d,h,min);
      if (m<1 || m>12 || d<1 || new Date(wall).getUTCDate()!==d || h>23 || min>59) return;
      const formatter = new Intl.DateTimeFormat('en-GB',{timeZone:'Europe/Rome',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',second:'2-digit',hourCycle:'h23'});
      let end = wall;
      for (let i=0;i<3;i++) {
        const zoned = Object.fromEntries(formatter.formatToParts(new Date(end)).map(p=>[p.type,p.value]));
        end += wall-Date.UTC(+zoned.year,+zoned.month-1,+zoned.day,+zoned.hour,+zoned.minute,+zoned.second);
      }
      const header = document.querySelector('.goodays-header');
      if(header) this.style.setProperty('--countdown-opacity',getComputedStyle(header).getPropertyValue('--goodays-header-opacity').trim() || '.3');
      const tick = () => {
        const seconds = Math.max(0,Math.ceil((end-Date.now())/1000));
        this.hidden = seconds===0;
        if (!seconds) { clearInterval(this.timer); return; }
        const values = {days:Math.floor(seconds/86400),hours:Math.floor(seconds/3600)%24,minutes:Math.floor(seconds/60)%60,seconds:seconds%60};
        for (const [unit,value] of Object.entries(values)) {
          const node = this.querySelector(`[data-unit="${unit}"]`);
          const text = String(value).padStart(2,'0');
          if(node.textContent!==text) node.textContent=text;
        }
      };
      tick();
      if (!this.hidden) this.timer=setInterval(tick,1000);
    }
    disconnectedCallback() { clearInterval(this.timer); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["goodays-instagram-size"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('goodays-instagram-size')) {
    customElements.define('goodays-instagram-size', class extends HTMLElement {
      connectedCallback() {
        if (!('IntersectionObserver' in window)) return;
        this.observer = new IntersectionObserver((entries) => {
          if (entries.some(entry => entry.isIntersecting)) {
            this.classList.add('is-visible');
            this.observer.disconnect();
          }
        }, { threshold: 0.5 });
        this.observer.observe(this);
      }
      disconnectedCallback() { this.observer?.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["goodays-password"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const timers = new Map();
    const initialize = (root) => {
      root.querySelectorAll('.goodays-password__password-form').forEach((form) => {
        if (form.querySelector('[role="alert"]')) form.closest('details').open = true;
      });
      root.querySelectorAll('[data-goodays-countdown]').forEach((countdown) => {
        if (timers.has(countdown)) return;
        const target = Date.parse(`${countdown.dataset.date}T${countdown.dataset.time || '00:00'}:00${countdown.dataset.offset || '+02:00'}`);
        const update = () => {
          const remaining = Math.max(0, Math.floor((target - Date.now()) / 60000));
          const values = Number.isFinite(remaining)
            ? [Math.floor(remaining / 1440), Math.floor(remaining / 60) % 24, remaining % 60]
            : [0, 0, 0];
          ['days', 'hours', 'minutes'].forEach((unit, index) => {
            countdown.querySelector(`[data-${unit}]`).textContent = String(values[index]).padStart(2, '0');
          });
        };
        update();
        timers.set(countdown, window.setInterval(update, 1000));
      });
    };
    initialize(document);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      timers.forEach((timer, element) => {
        if (event.target.contains(element)) {
          window.clearInterval(timer);
          timers.delete(element);
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page"]) return;
  try {
    
  if (!customElements.get('goodays-history-title')) {
    customElements.define('goodays-history-title', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const heading = this.querySelector('h1');
        if (!heading || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        const text = heading.textContent.trim();
        heading.setAttribute('aria-label', text);
        const fragment = document.createDocumentFragment();
        let index = 0;
        this.characters = [];
        text.split(' ').forEach((word, wordIndex) => {
          if (wordIndex) {
            fragment.append(document.createTextNode(' '));
            index++;
          }
          const wordSpan = document.createElement('span');
          wordSpan.className = 'goodays-history-title__word';
          wordSpan.setAttribute('aria-hidden', 'true');
          Array.from(word).forEach(character => {
            const span = document.createElement('span');
            span.className = 'goodays-history-title__char';
            span.textContent = character;
            wordSpan.append(span);
            this.characters.push({ span, index: index++ });
          });
          fragment.append(wordSpan);
        });
        heading.replaceChildren(fragment);
        this.animations = this.characters.map(({ span, index }) => span.animate([
          { opacity: 0, transform: 'translateY(30px)' },
          { opacity: 1, transform: 'translateY(0)' }
        ], { duration: 500, delay: index * 30, easing: 'cubic-bezier(0.175, 0.885, 0.32, 1.275)', fill: 'backwards' }));
      }
      disconnectedCallback() { this.animations?.forEach(animation => animation.cancel()); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
